import { BoxStatus } from "@/components/validations/models";

import { ChildTocItem, StepTocItem } from "../../../../editor/extensions/tableOfContents/models";

/**
 * Extension of StepTocItem with UI-specific properties
 */
export interface TocItem extends StepTocItem {
  /**
   * Whether the accordion for this item is open
   */
  isOpen: boolean;

  /**
   * Frontend only so we can track visibility of individual child items in the table of contents
   */
  childrenVisibility: Record<string, boolean>;
}

/**
 * Event dispatched when a TOC item is selected
 */
export type TocItemSelectedEvent = CustomEvent<{
  itemId: string;
}>;

/**
 * Maps a BoxStatus to its display label
 *
 * @param status - The box status
 * @returns A string label for the status
 */
export function getStatusLabel(status: BoxStatus | string): string {
  switch (status) {
    case BoxStatus.COMPLETE:
      return "Task done!";
    case BoxStatus.REVIEW:
      return "Task in-review";
    default:
    case BoxStatus.INCOMPLETE:
      return "Task still to complete";
  }
}

/**
 * Determines the type of a child item for display purposes
 *
 * @param child - The child item
 * @returns The display type of the child
 */
export function getChildDisplayType(child: ChildTocItem): "validation_box" | "bookmark" | "generic" {
  if (child.itemType === "validation") {
    return "validation_box";
  } else if (child.itemType === "bookmark") {
    return "bookmark";
  } else if (child.itemType === "generic") {
    return "generic";
  }
  return "generic";
}
